var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-star",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 21.6",
    style: {
      enableBackground: "new 0 0 22 21.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7,0.8L7.1,6.3l-5.9,1C0.4,7.3-0.1,8.2,0,8.8c0,0.3,0.2,0.5,0.3,0.7l4.4,4.4l-1,6.2c-0.2,0.7,0.3,1.3,1,1.5 c0.3,0,0.7,0,0.8-0.2l5.4-2.8l5.4,2.8c0.7,0.3,1.5,0,1.8-0.5c0.2-0.3,0.2-0.5,0.2-0.8l-1-6.2l4.4-4.4c0.5-0.5,0.5-1.3,0-2 c-0.2-0.2-0.5-0.3-0.7-0.3l-6.2-0.8l-2.7-5.5c-0.3-0.7-1-1-1.7-0.7C10.1,0.1,9.9,0.5,9.7,0.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2a7cc23a834db5d238c2f7e6791e0cf7.svg";
export { ForwardRef as ReactComponent };